export default [
  {
    path: "/mobilereg/:slug",
    name: "mobile.location.reg",
    component: () => import("@/pages/frontend/mobilelocation/index")
  }
];
